export default [
    {
      path: '/midFes/index',
      meta:{
        title: '悦好吃 月团圆'
      },
      component: (resolve) => require(['@/pages/midFes/index'], resolve)
    }
  ]
  